
import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';
import { FilterFormulaGroup } from '../../../models/filters/filter-formula-group';
import { FormulaGroupService } from '../../../services/formula-group.service';

@Component({
  selector: 'app-formulas',
  standalone: false,
  templateUrl: './formulas.component.html',
  styleUrl: './formulas.component.css'
})
export class FormulasComponent {

  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  @ViewChild(TableComponent) formulasTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterFormulaGroup: FilterFormulaGroup = new FilterFormulaGroup;
  advancedSearch: boolean = false;
  
  private formulaGroupService = inject(FormulaGroupService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterFormulaGroup = new FilterFormulaGroup();
    this.searchFormulaGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchFormulaGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/formulasGroup/edit', event.id]);
  }
  addNewFormulaGroup(){
    this.router.navigate(['/formulasGroup/edit', 0]);
  }

  searchFormulaGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchFormulaGroupPaginator();
  }

  searchFormulaGroupPaginator(){
    this.loading = true;

    this.formulaGroupService.findAllPageableFormulaGroup(this.filterFormulaGroup, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.formulasTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
